module.exports = __webpack_public_path__ + "img/adesivagem_vidro2.fa0d6af9.jpg";